// uploadSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import Axios from "../../utils/Axios";
import AuthHandler from "../../utils/AuthHandler";
import { navigate } from "../../utils/navigation";
import { DOCUMENT_UPLOAD } from "../../config/API_Collection";
import { getErrorMessage } from "../../config/Error_Codes";
import {
  UPLOAD_PROJECT_FILE_FAILURE,
  UPLOAD_PROJECT_FILE_REQUEST,
  UPLOAD_PROJECT_FILE_SUCCESS,
  UPLOAD_PROFILE_FILE_REQUEST,
  UPLOAD_PROFILE_FILE_SUCCESS,
  UPLOAD_PROFILE_FILE_FAILURE,
} from "../Actions/Actions";

function* uploadFileSaga({ type, payload }) {
  try {
    const { file, file_name, section, profile_name } = payload || {};
    if (!file) throw new Error("File is required");

    const formData = new FormData();
    formData.append("file", file);
    // Prefer explicit file_name, then special handling for profile, else fallback
    const computedName =
      file_name || (section === "profile" ? profile_name : null) || file.name;
    formData.append("file_name", computedName);
    formData.append("section", section || (type === UPLOAD_PROFILE_FILE_REQUEST ? "profile" : "project"));

    const response = yield call(Axios.post, DOCUMENT_UPLOAD, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    // Expecting { data: { document_id, file_name, blob_path, ... } }
    // Debug: log response for troubleshooting 500s
    try {
      // eslint-disable-next-line no-console
      console.debug('uploadFileSaga response status:', response?.status, 'data:', response?.data);
    } catch (e) {}
    const data = response?.data?.data ?? response?.data ?? {};

    // Attach originating slotIndex to response data when provided so UI can map exactly
    if (typeof payload?.slotIndex === 'number') {
      try {
        // prefer not to mutate original but attach helper property
        data._slotIndex = payload.slotIndex;
      } catch (e) {
        // ignore
      }
    }

    // Route success to the correct action by source
    if (type === UPLOAD_PROFILE_FILE_REQUEST) {
      yield put({ type: UPLOAD_PROFILE_FILE_SUCCESS, payload: { data } });
    } else {
      yield put({ type: UPLOAD_PROJECT_FILE_SUCCESS, payload: { data } });
    }
  } catch (error) {
    // Handle auth and map to message
    yield call(AuthHandler, error?.response?.status, null, navigate);
    const failureType =
      (payload?.section === "profile") || (typeof type !== "undefined" && type === UPLOAD_PROFILE_FILE_REQUEST)
        ? UPLOAD_PROFILE_FILE_FAILURE
        : UPLOAD_PROJECT_FILE_FAILURE;

    // Build failure payload with debug info and original file_name/slotIndex so UI can recover
    const message =
      getErrorMessage(error?.response?.status) || error?.message || (error?.response?.data && JSON.stringify(error.response.data)) || "Upload failed";
    const failurePayload = {
      message,
      file_name: payload?.file_name,
      slotIndex: payload?.slotIndex,
      status: error?.response?.status,
      details: error?.response?.data || null,
    };
    // eslint-disable-next-line no-console
    console.error('uploadFileSaga error', failurePayload);
    yield put({
      type: failureType,
      payload: failurePayload,
    });
  }
}

export default function* uploadWatcher() {
  yield takeLatest(UPLOAD_PROJECT_FILE_REQUEST, uploadFileSaga);
  yield takeLatest(UPLOAD_PROFILE_FILE_REQUEST, uploadFileSaga);
}
